import React from 'react'

// App pricing, allowances and account requirements need a current provider
// record. Repeating a claim elsewhere on this site does not verify it.
const ITEMS = ['iOS app', 'Current terms on the App Store'] as const

export interface AppCtaTrustRowProps {
  /** Tighter type + spacing for the compact hero ribbon. */
  size?: 'sm' | 'md'
  className?: string
}

export default function AppCtaTrustRow({ size = 'md', className = '' }: AppCtaTrustRowProps) {
  const text = size === 'sm' ? 'text-2xs' : 'text-xs'
  return (
    <ul
      aria-label="iOS app; current terms on the App Store"
      className={`not-prose flex flex-wrap items-center gap-x-2.5 gap-y-1 ${text} font-medium text-gray-500 ${className}`}
    >
      {ITEMS.map((item, i) => (
        <li key={item} className="inline-flex items-center gap-2">
          {i > 0 && (
            <span aria-hidden="true" className="text-gray-300">
              ·
            </span>
          )}
          <span className="inline-flex items-center gap-1">
            <svg
              className="w-3 h-3 text-[#3DDC84]"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0l-3.5-3.5a1 1 0 011.4-1.4l2.8 2.79 6.8-6.79a1 1 0 011.4 0z"
                clipRule="evenodd"
              />
            </svg>
            {item}
          </span>
        </li>
      ))}
    </ul>
  )
}

AppCtaTrustRow.displayName = 'AppCtaTrustRow'
